import { gql } from "apollo-boost";
import { idtype, heroImg, fullPageImage, inlineImage } from 'querypieces';


export default gql`
    query($uri: String) {
        entry(uri: [$uri]) {
            ${idtype}
            uri
            ... on reports_Entry {
                id
                title
                ${heroImg}
                heroHeading: plainText
                breadcrumb
                heading
                introBody
                body
                richText
                cta {
                  title
                  text
                  type
                  url
                  element {
                    uri
                  }
                }
                children {
                    ... on chapter_Entry {
                        id
                        uri
                        url
                        title
                        slug
                        reportBuilder {
                            ... on reportBuilder_fullPagePhotoMatrix_BlockType {
                                ${idtype}
                                id
                                themePicker
                                fullPagePhotoMatrix {
                                  ... on fullPagePhoto_Entry {
                                    id
                                    altText
                                    photoBorderSwitch
                                    ${fullPageImage}
                                  }
                                  ... on header_Entry {
                                    id
                                    header
                                  }
                                  ... on subheader_Entry {
                                    id
                                    subheader
                                  }
                                  ... on introBody_Entry {
                                    id
                                    introBody
                                  }
                                  ... on body_Entry {
                                    id
                                    body
                                  }
                                  ... on cta_Entry {
                                    id
                                    cta {
                                        text
                                        type
                                        url
                                        element {
                                          uri
                                        }
                                    }
                                  }
                                }
                            }
                            ... on reportBuilder_inlinePhotoMatrix_BlockType {
                                ${idtype}
                                inlinePhotoMatrix {
                                  ... on inlinePhoto_Entry {
                                    id
                                    altText
                                    photoBorderSwitch
                                    ${inlineImage}
                                  }
                                  ... on bigHeader_Entry {
                                    id
                                    header
                                  }
                                  ... on bodyCopy_Entry {
                                    id
                                    body
                                  }
                                  ... on subheader2_Entry {
                                    id
                                    subheader
                                  }
                                  ... on cta2_Entry {
                                    id
                                    cta {
                                        title
                                        text
                                        type
                                        url
                                        element {
                                            uri
                                        }
                                    }
                                  }
                                  ... on contactDownloadCta_Entry {
                                    id
                                    phoneNumber {
                                        url
                                        customText
                                        text
                                    }
                                    email {
                                        url
                                        text
                                        customText
                                    }
                                    location
                                    downloadCta {
                                        url
                                        text
                                        type
                                    }
                                  }
                                }
                              }

                        }
                    }
                }
            }
        }
    }
`;